import React, { useState } from "react";
import axios from "axios";
import { API_URL } from "../config";
import { withAuth } from "./withAuth";
import Header from "../components/Header";
import { Form } from "react-bootstrap";
import { Card, Button, Title, Text } from "@mantine/core";

function UpdatePasswordPage() {
  const [message, setMessage] = useState("");

  const userId = localStorage.getItem("userId");

  const handleSubmit = (e) => {
    e.preventDefault();
    const oldPassword = e.target.password.value;
    const newPassword = e.target.newPassword.value;
    const newPasswordConfirm = e.target.confirmNewPassword.value;

    if (!oldPassword || !newPassword || !newPasswordConfirm) {
      setMessage("Please fill out all fields.");
      return;
    }

    if (newPassword !== newPasswordConfirm) {
      setMessage("Passwords do not match.");
      return;
    }
    axios
      .put(`${API_URL}/users/${userId}/password`, {
        oldPassword: oldPassword,
        newPassword: newPassword,
      })
      .then((response) => {
        if (response.data.status === 200) {
          setMessage("Password updated successfully.");
        } else {
          setMessage("Current password is incorrect.");
        }
      });
  };

  return (
    <>
      <Header />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          height: "100vh",
          width: "100vw",
        }}
      >
        <Card
          style={{
            marginBottom: "7rem",
            width: "300px",
            height: "370px",
            borderRadius: "10px",
            boxShadow: "0 0 5px 2px rgba(0, 0, 0, .3)",
          }}
        >
          <Title align="center" order={2}>
            Update Password
          </Title>
          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Label>Current Password</Form.Label>
              <Form.Control type="password" name="password" />
            </Form.Group>
            <Form.Group>
              <Form.Label>New Password</Form.Label>
              <Form.Control type="password" name="newPassword" />
            </Form.Group>
            <Form.Group>
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control type="password" name="confirmNewPassword" />
            </Form.Group>
            <Text align="center" style={{ color: "red" }}>
              {message}
            </Text>
            <Button
              className="w-75"
              variant="outline"
              type="submit"
              style={{ position: "absolute", right: "2.5rem", top: "19rem" }}
            >
              Update Password
            </Button>
          </Form>
        </Card>
      </div>
    </>
  );
}

export default withAuth(UpdatePasswordPage);
